import type { MongoAbility } from '@casl/ability'
import { AbilityBuilder, createMongoAbility } from '@casl/ability'

export const SUBJECTS = {
  Billing: 'Billing',
  Campaign: 'Campaign',
  Category: 'Category',
  Communication: 'Communication',
  Company: 'Company',
  Customer: 'Customer',
  Dashboard: 'Dashboard',
  Driver: 'Driver',
  Employee: 'Employee',
  File: 'File',
  Integration: 'Integration',
  Job: 'Job',
  Leave: 'Leave',
  LoanCar: 'LoanCar',
  PackageDeal: 'PackageDeal',
  Pricing: 'Pricing',
  Product: 'Product',
  Qualification: 'Qualification',
  Role: 'Role',
  Service: 'Service',
  Settings: 'Settings',
  Store: 'Store',
  UnionAgreement: 'UnionAgreement',
  User: 'User',
  Vehicle: 'Vehicle',
  WorkLog: 'WorkLog',
  all: 'all',
} as const

export type Subjects = (typeof SUBJECTS)[keyof typeof SUBJECTS]

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage'

export type AppAbility = MongoAbility<[Actions, Subjects]>

export type Role = 'admin' | 'manager' | 'technician' | 'viewer'

// Returns an empty ability (deny everything) — used as a pre-login fallback.
// All real permissions are loaded from the /role_with_permissions API.
export const defineAbilitiesFor = (_role: Role): AppAbility => {
  const { build } = new AbilityBuilder<AppAbility>(createMongoAbility)
  return build()
}

export interface Permission {
  action: string
  subject: string
}

export const defineAbilitiesFromPermissions = (permissions: Permission[]): AppAbility => {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility)

  permissions.forEach(({ action, subject }) => {
    can(action as Actions, subject as Subjects)
  })

  return build()
}
